<template>
    <div v-if="!loading && loaded" class="chart" :style="`height: ${outerHeight}`">
        <apexchart type="bar" :height="innerHeight" :options="options" :series="series"></apexchart>
    </div>
</template>

<script>
import apexchart from 'vue-apexcharts';

export default {
    name: 'ResultsBySubjectChart',
    components: { apexchart },
    props: {
        height: Number,
        loading: Boolean
    },
    data: () => ({
        outerHeight: 'auto',
        innerHeight: 'auto',
        options: {
            chart: {
                type: 'bar',
                width: '100%',
                toolbar: {
                    show: false
                },
                events: {
                    mounted: (chart) => {
                        chart.windowResizeHandler();
                    }
                }
            },
            plotOptions: {
                bar: {
                    barHeight: "14%",
                    borderRadius: 4,
                    horizontal: true,
                }
            },
            dataLabels: {
                enabled: false
            },
            xaxis: {
                categories: []
            },
            legend: {
                showForSingleSeries: true,
                markers: {
                    strokeColor: '#717BF9',
                    radius: 12
                }
            },
            tooltip: {
                y: {
                    formatter: (value, options) => {
                        return value.toFixed(0);
                    }
                }
            }
        },
        series: [{
            name: 'Количество пройденных заданий',
            data: []
        }],
        loaded: false
    }),
    methods: {
        update(categories, series) {
            let splitted = [];
            
            categories.forEach(x => {
                let values = x.split(' ');
                splitted.push(values);
            });

            this.options.xaxis.categories = splitted;
            this.series[0].data = series;

            this.loaded = true;
        }
    },
    created() {
        if (this.height > 0) {
            this.outerHeight = `${this.height}px`;
            this.innerHeight = (this.height - 20).toString();
        }
    }
}
</script>
